import md5 from 'js-md5'
const TokenKey = md5('hq_token')

export function getToken () {
    return localStorage.getItem(TokenKey)
}

export function setToken (token) {
    return localStorage.setItem(TokenKey, token)
}

export function removeToken () {
    return localStorage.removeItem(TokenKey)
}

// 检查Token是否存在
export function hasToken () {
    const token = getToken()
    return token && token.length > 0
}

// 检查Token是否可能过期（简单的时间戳检查）
export function isTokenExpired () {
    const token = getToken()
    if (!token) return true
    
    try {
        // 如果token包含时间戳信息，可以在这里解析检查
        // 这里提供一个简单的检查方法
        return false
    } catch (error) {
        console.error('Token检查失败:', error)
        return false
    }
}

// 清除所有认证相关的本地存储
export function clearAuthData () {
    removeToken()
    // 可以在这里清除其他认证相关的数据
    localStorage.removeItem('userInfo')
    sessionStorage.clear()

}

// 定期检查Token有效性
export function startTokenCheck (store, checkInterval = 5 * 60 * 1000) { // 默认5分钟检查一次
    if (typeof window === 'undefined') return
    
    const checkToken = () => {
        if (!hasToken()) {
            console.log('Token不存在，停止检查')
            return
        }
        
        // 这里可以添加更复杂的Token有效性检查逻辑
        // 例如检查Token的过期时间等
        
        // 如果检测到Token可能过期，可以提前提示用户
        if (isTokenExpired()) {
            console.warn('Token可能已过期，建议重新登录')
        }
    }
    
    // 立即执行一次检查
    checkToken()
    
    // 设置定期检查
    const intervalId = setInterval(checkToken, checkInterval)
    
    // 返回清理函数
    return () => {
        clearInterval(intervalId)
    }
}
